import { render } from "./Spinner.vue?vue&type=template&id=cf10cb90&scoped=true"
const script = {}

import "./Spinner.vue?vue&type=style&index=0&id=cf10cb90&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf10cb90"]])

export default __exports__